import { Button, HStack, Icon, Text, VStack } from '@chakra-ui/react'
import { Paperclip } from 'lucide-react'
import { useContext } from 'react'
import { useDropzoneStyles } from '~/components/shared/componentStyles/Dropzone.style'
import { Size } from '~/types/ThemeTypes'
import { formatFileSize } from '~/utils/common'

import { Context } from './Context'

export default function ContentAcceptedSingle() {
  const { acceptedFiles, currentVariant, resetAllState } = useContext(Context)

  const file = acceptedFiles[0]

  const styles = useDropzoneStyles({
    variant: currentVariant,
  })

  return (
    <>
      <HStack>
        <Icon css={styles.icon}>
          <Paperclip size="100%" />
        </Icon>
        <VStack>
          <Text css={styles.text}>
            {file.name} ({formatFileSize(file.size)})
          </Text>
        </VStack>
      </HStack>
      <HStack>
        <Button
          css={styles.clearButton}
          variant="plain"
          size={Size.sm}
          onClick={resetAllState}
        >
          Clear
        </Button>
      </HStack>
    </>
  )
}
